module.exports = __webpack_public_path__ + "static/2d8fca353bbca12ee104f229c2489958fb7d867c4b09be08aee2364010636fab-ae582f0fb9725a86b1801932ab21b457.png";